// src/components/Admin/ChatManager/Category/CategoryForm.jsx
import { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, FormControlLabel, Checkbox,
    FormControl, RadioGroup, Radio, Typography,
    useTheme, useMediaQuery          // ⬅ 추가
} from '@mui/material';
import { createChatCategory, editChatCategory } from '../../../../api/admin';

const CategoryForm = ({
    open, onClose, category, isEdit, reload, reloadCategories,
}) => {
    /* ─ responsive ───────────────────────────── */
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 600px 미만

    /* ─ form 상태 ────────────────────────────── */
    const [form, setForm] = useState({
        name: '', description: '', anonymous_option: 'none',
        emoji: '💬', is_private_only: false, password: '',
    });

    useEffect(() => {
        if (isEdit && category) {
            setForm({ ...category, password: category.password || '' });
        } else {
            setForm({
                name: '', description: '', anonymous_option: 'none',
                emoji: '💬', is_private_only: false, password: ''
            });
        }
    }, [category, isEdit, open]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = () => {
        if (!form.name.trim()) return alert('카테고리명을 입력하세요.');
        if (form.is_private_only && !form.password.trim())
            return alert('비공개 채팅방에는 비밀번호가 필요합니다.');

        const apiCall = isEdit ? editChatCategory(form.id, form)
            : createChatCategory(form);
        apiCall
            .then(() => { reload(); reloadCategories(); onClose(); })
            .catch(() => alert('저장 실패'));
    };

    /* ─ render ───────────────────────────────── */
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={isMobile ? 'xs' : 'sm'}               // ⬅ 모바일이면 한 단계 작은(xs) 폭
            PaperProps={{ sx: { p: isMobile ? 2 : 3 } }}    // ⬅ 여백도 축소
        >
            <DialogTitle>{isEdit ? '카테고리 수정' : '카테고리 추가'}</DialogTitle>

            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isMobile ? 1.5 : 2,                    // ⬅ 간격 축소
                    mt: 1,
                }}
            >
                <TextField
                    size={isMobile ? 'small' : 'medium'}         // ⬅ 컴팩트 폼 요소
                    name="name"
                    label="카테고리명"
                    value={form.name}
                    onChange={handleChange}
                    fullWidth
                    required
                />

                <TextField
                    size={isMobile ? 'small' : 'medium'}
                    name="description"
                    label="설명"
                    value={form.description}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={3}
                />

                <FormControl>
                    <Typography sx={{ mb: 1, fontSize: isMobile ? '0.9rem' : '1rem' }}>
                        익명 채팅방 여부
                    </Typography>
                    <RadioGroup
                        row
                        name="anonymous_option"
                        value={form.anonymous_option}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="none" control={<Radio size={isMobile ? 'small' : 'medium'} />} label="일반 채팅방" />
                        <FormControlLabel value="force" control={<Radio size={isMobile ? 'small' : 'medium'} />} label="익명 채팅방" />
                    </RadioGroup>
                </FormControl>

                <TextField
                    size={isMobile ? 'small' : 'medium'}
                    name="emoji"
                    label="이모지 (예: 💬 🔒 😊)"
                    value={form.emoji}
                    onChange={handleChange}
                    inputProps={{ maxLength: 2 }}
                    fullWidth
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            size={isMobile ? 'small' : 'medium'}
                            name="is_private_only"
                            checked={form.is_private_only}
                            onChange={handleChange}
                        />
                    }
                    label="비공개 (비밀번호 필요)"
                    sx={{ '.MuiTypography-root': { fontSize: isMobile ? '0.9rem' : '1rem' } }}
                />

                {form.is_private_only && (
                    <TextField
                        size={isMobile ? 'small' : 'medium'}
                        name="password"
                        label="비밀번호"
                        type="text"
                        value={form.password}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                )}
            </DialogContent>

            <DialogActions sx={{ px: isMobile ? 2 : 3, pb: isMobile ? 2 : 3 }}>
                <Button onClick={onClose}>취소</Button>
                <Button variant="contained" onClick={handleSubmit}>
                    {isEdit ? '수정' : '추가'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CategoryForm;
